import { IWidgetsTradingPairsCategories } from 'interfaces/catalog';

export const totalNodes = 11;
export const clanPercent = 51;
export const plusNodes = 5;
export const exchangeCallingAttempts = 20;
export const doraDefaultVersion = '2';
export const DATA_MAIN_PAGE_TABLE_COLUMNS = [
	{
		Header: 'Pair',
		accessor: 'displayName',
	},
	{
		Header: 'PRICE',
		accessor: 'price',
	},
	{
		Header: 'Market Cap',
		accessor: 'marketCap',
	},
	// {
	//   Header: 'Last update',
	//   accessor: 'lastUpdate',
	// },
	{
		Header: '1H %',
		accessor: 'volume1h',
	},
	{
		Header: '24H %',
		accessor: 'volume24h',
	},
	{
		Header: '7D %',
		accessor: 'volume7d',
	},
	{
		Header: 'Last 7 days',
		accessor: 'sevenDayOfStateChart',
	},
];

export const DATA_MAIN_PAGE_NETWORK_DATA = [
	{
		id: 1,
		icon: '',
		title: 'Supra',
		value: '$1.01',
	},
	{
		id: 2,
		icon: '',
		title: 'Cerberus',
		value: '$1.01',
	},
	{
		id: 3,
		icon: '',
		title: 'Binance',
		value: '$30,076.03',
	},
	{
		id: 4,
		icon: '',
		title: 'Kucoin',
		value: '$30,056.00',
	},
	{
		id: 5,
		icon: '',
		title: 'Coinbase',
		value: '$30,081.09',
	},
	{
		id: 6,
		icon: '',
		title: 'Kraken',
		value: '$30,077.03',
	},
];

export const WIDGET_CATEGORIES_DROPDOWN: IWidgetsTradingPairsCategories[] = [
	{
		id: '1',
		category: 'Crypto',
		subCategory: 'crypto',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/btcIcon.svg',
	},
	{
		id: '2',
		category: 'Forex',
		subCategory: 'forex',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/forexIcon.svg',
	},
	{
		id: '3',
		category: 'Commodities',
		subCategory: 'commodities',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/commoditiesIcon.svg',
	},
	{
		id: '4',
		category: 'Equities',
		subCategory: 'equities',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/equitiesIcon.svg',
	},
	{
		id: '5',
		category: 'Primary Exchange Rate',
		subCategory: 'primaryExchangeRate',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/primaryExchangeRateIcon.svg',
	},
	{
		id: '6',
		category: 'ETFs',
		subCategory: 'etfs',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/etfsIcon.svg',
	},
	{
		id: '7',
		category: 'Circulating Supply',
		subCategory: 'circulatingSupply',
		icon_url: 'https://qa-assets.cerberus.supra.com/images/icons/circulatingSupplyIcon.svg',
	},
];

export const EXCHANGE_LIST: { [key: string]: string } = {
	Okex: 'OKX',
	'Crypto dot com': 'Crypto.com',
	'Noves(TraderJoe v2.1)': 'Traderjoe v2.1',
	'Dex screener(TraderJoe v2.1)': 'Traderjoe v2.1',
	'Mobula(TraderJoe v2.1)': 'Traderjoe v2.1',
	'Coingecko terminal(TraderJoe v2.1)': 'Traderjoe v2.1',
	'Blockin ai(TraderJoe v2.1)': 'Traderjoe v2.1',
	'Dex screener(Uniswap)': 'UniSwap v3',
	'Coingecko terminal(Uniswap)': 'UniSwap v3',
	'Noves(Agni Finance)': 'Agni finance',
	'Mobula(Agni Finance)': 'Agni finance',
	'Mobula(FusionX v3)': 'FusionX v3',
	'Noves(iZiSwap)': 'iZiSwap',
	'Mobula(iZiSwap)': 'iZiSwap',
	'Coingecko terminal(FusionX v3)': 'FusionX v3',
	'Noves(FusionX v3)': 'FusionX v3',
	'Dex screener(Uniswap V3)': 'UniSwap v3',
	'Dex screener(FusionX v3)': 'FusionX v3',
	'Dex screener(Agni Finance)': 'Agni finance',
	'Mobula(Turbos Finance)': 'Turbos Finance',
	'Blockin ai(Turbos Finance)': 'Turbos Finance',
	'Dex screener(Turbos Finance)': 'Turbos Finance',
	'Mobula(Cetus)': 'Cetus',
	'Dex screener(Cetus)': 'Cetus',
	'Coingecko terminal(Cetus)': 'Cetus',
	'Noves(Cetus)': 'Cetus',
	'Blockin ai(Cetus)': 'Cetus',
	'Noves(KryiaDEX)': 'Cetus',
	'Coingecko terminal': 'CoinGecko',
	'Coingecko terminal(Turbos Finance)': 'Turbos Finance',
	'Noves(Turbos Finance)': 'Turbos Finance',
	'Dex screener(Aftermath Finance)': 'Aftermath Finance',
	'Coingecko terminal(Aftermath Finance)': 'Aftermath Finance',
	'Mobula(Aftermath Finance)': 'Aftermath Finance',
	'Noves(Aftermath Finance)': 'Aftermath Finance',
	'Blockin ai(Aftermath Finance)': 'Aftermath Finance',
	'Dex screener(KriyaDEX)': 'KriyaDEX',
	'Coingecko terminal(KriyaDEX)': 'KriyaDEX',
	'Mobula(KriyaDEX)': 'KriyaDEX',
	'Noves(KriyaDEX)': 'KriyaDEX',
	'Blockin ai(KriyaDEX)': 'KriyaDEX',
	'Dex screener(StellaSwap)': 'StellaSwap',
	'Coingecko terminal(StellaSwap)': 'StellaSwap',
	'Mobula(StellaSwap)': 'StellaSwap',
	'Noves(StellaSwap)': 'StellaSwap',
	'Blockin ai(StellaSwap)': 'StellaSwap',
	'Dex screener(BeamSwap)': 'BeamSwap',
	'Coingecko terminal(BeamSwap)': 'BeamSwap',
	'Mobula(BeamSwap)': 'BeamSwap',
	'Noves(BeamSwap)': 'BeamSwap',
	'Blockin ai(BeamSwap)': 'BeamSwap',
	'Coingecko terminal(Agni Finance)': 'Agni finance',
	'Blockin ai(Agni Finance)': 'Agni finance',
	'Blockin ai(FusionX v3)': 'FusionX v3',
	'Dex screener(iZUMi)': 'iZUMi',
	'Coingecko terminal(iZUMi)': 'iZUMi',
	'Mobula(iZUMi)': 'iZUMi',
	'Noves(iZUMi)': 'iZUMi',
	'Blockin ai(iZUMi)': 'iZUMi',
	'Dex screener(UniSwap v3)': 'UniSwap v3',
	'Coingecko terminal(UniSwap v3)': 'UniSwap v3',
	'Mobula(UniSwap v3)': 'UniSwap v3',
	'Noves(UniSwap v3)': 'UniSwap v3',
	'Blockin ai(UniSwap v3)': 'UniSwap v3',
	'Dex screener(PancakeSwap v2)': 'PancakeSwap v2',
	'Dex screener(PancakeSwap V2)': 'PancakeSwap v2',
	'Dex screener(PancakeSwap v3)': 'PancakeSwap v3',
	'Dex screener(PancakeSwap V3)': 'PancakeSwap v3',
	'Coingecko terminal(PancakeSwap v2)': 'PancakeSwap v2',
	'Coingecko terminal(PancakeSwap V2)': 'PancakeSwap v2',
	'Mobula(PancakeSwap v2)': 'PancakeSwap v2',
	'Mobula(PancakeSwap V2)': 'PancakeSwap v2',
	'Noves(PancakeSwap v2)': 'PancakeSwap v2',
	'Noves(PancakeSwap V2)': 'PancakeSwap v2',
	'Blockin ai(PancakeSwap v2)': 'PancakeSwap v2',
	'Blockin ai(PancakeSwap V2)': 'PancakeSwap v2',
	'Mobula(PancakeSwap v3)': 'PancakeSwap v3',
	'Mobula(PancakeSwap V3)': 'PancakeSwap v3',
	'Noves(PancakeSwap V3)': 'PancakeSwap v3',
	'Noves(PancakeSwap v3)': 'PancakeSwap v3',
	'Dex screener(SushiSwap v3)': 'SushiSwap v3',
	'Coingecko terminal(SushiSwap v3)': 'SushiSwap v3',
	'Mobula(SushiSwap v3)': 'SushiSwap v3',
	'Noves(SushiSwap v3)': 'SushiSwap v3',
	'Blockin ai(SushiSwap v3)': 'SushiSwap v3',
	'Dex screener(Curve)': 'Curve ',
	'Coingecko terminal(Curve)': 'Curve ',
	'Mobula(Curve)': 'Curve ',
	'Blockin ai(Curve)': 'Curve ',
	'Noves(Curve)': 'Curve ',
	'Dex screener(Butter.XYZ)': 'Butter.XYZ',
	'Coingecko terminal(Butter.XYZ)': 'Butter.XYZ',
	'Blockin ai(Butter.XYZ)': 'Butter.XYZ',
	'Mobula(Butter.XYZ)': 'Butter.XYZ',
	'Noves(Butter.XYZ)': 'Butter.XYZ',
	'Dex screener(iZiSwap)': 'iZiSwap',
	'Coingecko terminal(iZiSwap)': 'iZiSwap',
	'Blockin ai(iZiSwap)': 'iZiSwap',
	'Dex screener(ApeSwap)': 'ApeSwap',
	'Coingecko terminal(ApeSwap)': 'ApeSwap',
	'Mobula(ApeSwap)': 'ApeSwap',
	'Noves(ApeSwap)': 'ApeSwap',
	'Blockin ai(ApeSwap)': 'ApeSwap',
	'Dex screener(Shimmer Sea)': 'Dex screener',
	'Coingecko terminal(Shimmer Sea)': 'CoinGecko',
	'Dex screener(UniSwap)': 'UniSwap',
	'Coingecko terminal(UniSwap)': 'UniSwap',
	'Mobula(UniSwap)': 'UniSwap',
	'Noves(UniSwap)': 'UniSwap',
	'Blockin ai(UniSwap)': 'UniSwap',
	'Dex screener(BiSwap)': 'BiSwap',
	'Coingecko terminal(BiSwap)': 'BiSwap',
	'Mobula(BiSwap)': 'BiSwap',
	'Noves(BiSwap)': 'BiSwap',
	'Blockin ai(BiSwap)': 'BiSwap',
	'Dex screener(Thena v1)': 'Thena v1',
	'Coingecko terminal(Thena v1)': 'Thena v1',
	'Mobula(Thena v1)': 'Thena v1',
	'Noves(Thena v1)': 'Thena v1',
	'Blockin ai(Thena v1)': 'Thena v1',
	'Dex screener(ApertureSwap)': 'ApertureSwap',
	'Coingecko terminal(ApertureSwap)': 'ApertureSwap',
	'Mobula(ApertureSwap)': 'ApertureSwap',
	'Noves(ApertureSwap)': 'ApertureSwap',
	'Blockin ai(ApertureSwap)': 'ApertureSwap',
	'Dex screener(QuickSwap)': 'QuickSwap',
	'Coingecko terminal(QuickSwap)': 'QuickSwap',
	'Mobula(QuickSwap)': 'QuickSwap',
	'Noves(QuickSwap)': 'QuickSwap',
	'Blockin ai(QuickSwap)': 'QuickSwap',
	'Dex screener(PacificSwap)': 'PacificSwap',
	'Coingecko terminal(PacificSwap)': 'PacificSwap',
	'Mobula(PacificSwap)': 'PacificSwap',
	'Noves(PacificSwap)': 'PacificSwap',
	'Blockin ai(PacificSwap)': 'PacificSwap',
	'Dex screener(SaucerSwap v1)': 'SaucerSwap v1',
	'Coingecko terminal(SaucerSwap v1)': 'SaucerSwap v1',
	'Mobula(SaucerSwap v1)': 'SaucerSwap v1',
	'Noves(SaucerSwap v1)': 'SaucerSwap v1',
	'Blockin ai(SaucerSwap v1)': 'SaucerSwap v1',
	'Dex screener(SaucerSwap v2)': 'SaucerSwap v2',
	'Coingecko terminal(SaucerSwap v2)': 'SaucerSwap v2',
	'Mobula(SaucerSwap v2)': 'SaucerSwap v2',
	'Noves(SaucerSwap v2)': 'SaucerSwap v2',
	'Blockin ai(SaucerSwap v2)': 'SaucerSwap v2',
	'Dex screener(Pangolin)': 'Pangolin',
	'Coingecko terminal(Pangolin)': 'Pangolin',
	'Mobula(Pangolin)': 'Pangolin',
	'Noves(Pangolin)': 'Pangolin',
	'Blockin ai(Pangolin)': 'Pangolin',
	'Dex screener(TraderJoe)': 'Traderjoe',
	'Coingecko terminal(TraderJoe)': 'Traderjoe',
	'Mobula(TraderJoe)': 'Traderjoe',
	'Noves(TraderJoe)': 'Traderjoe',
	'Blockin ai(TraderJoe)': 'Traderjoe',
	'Dex screener(Camelot v3)': 'Camelot v3',
	'Coingecko terminal(Camelot v3)': 'Camelot v3',
	'Mobula(Camelot v3)': 'Camelot v3',
	'Noves(Camelot v3)': 'Camelot v3',
	'Blockin ai(Camelot v3)': 'Camelot v3',
	'Dex screener(Balancer)': 'Balancer',
	'Coingecko terminal(Balancer)': 'Balancer',
	'Mobula(Balancer)': 'Balancer',
	'Blockin ai(Balancer)': 'Balancer',
	'Noves(Balancer)': 'Balancer',
	'Dex screener(Camelot)': 'Camelot',
	'Coingecko terminal(Camelot)': 'Camelot',
	'Mobula(Camelot)': 'Camelot',
	'Noves(Camelot)': 'Camelot',
	'Blockin ai(Camelot)': 'Camelot',
	'Mobula(Shimmer Sea)': 'Mobula',
	'Noves(Shimmer Sea)': 'Noves',
	'Blockin ai(Shimmer Sea)': 'Shimmer Sea',
	'Twelve data': 'Twelve Data',
	'Six group': 'Six Group',
	'Morning star': 'Morning Star',
	'Dex screener(SushiSwap)': 'SushiSwap',
	'Coingecko terminal(SushiSwap)': 'SushiSwap',
	'Mobula(SushiSwap)': 'SushiSwap',
	'Noves(SushiSwap)': 'SushiSwap',
	'Blockin ai(SushiSwap)': 'SushiSwap',
	'Dex screener(Balancer v2)': 'Balancer v2',
	'Coingecko terminal(Balancer v2)': 'Balancer v2',
	'Mobula(Balancer v2)': 'Balancer v2',
	'Blockin ai(Balancer v2)': 'Balancer v2',
	'Noves(Balancer v2)': 'Balancer v2',
	Kucoin: 'Kucoin',

	Bingex: 'Bingx',
	Coinex: 'CoinEx',
	'Xt dot com': 'XT.com',
	Lbank: 'lbank',
	Coinw: 'CoinW',

	'Dex screener(Bluemove)': 'BlueMove',
	'Dex screener(BlueMove)': 'BlueMove',
	'Mobula(Bluemove)': 'BlueMove',
	'Mobula(BlueMove)': 'BlueMove',
	'Coingecko terminal(BlueMove)': 'BlueMove',
	'Dex screener(ArthSwap)': 'Dexscreener',
	'Mobula(ArthSwap)': 'Mobula',
	'Coingecko terminal(ArthSwap)': 'CoinGecko',
	'Mobula(Solidly)': 'Solidly',
	'Noves(Solidly)': 'Solidly',
	'Dex screener(Ramses v2)': 'Ramses v2',
	'Coingecko terminal(Ramses v2)': 'Ramses v2',
	'Noves(Ramses v2)': 'Ramses v2',
	'Mobula(Ramses v2)': 'Ramses v2',
	'Ethereum-1': 'Ethereum',
	'Ethereum-2': 'Ethereum',
	'Ethereum-3': 'Ethereum',
	'Ethereum-4': 'Ethereum',
	'Ethereum-5': 'Ethereum',
	'Mantle-1': 'Mantle',
	'Mantle-2': 'Mantle',
	'Mantle-3': 'Mantle',
	'Mantle-4': 'Mantle',
};
